if (window.self !== window.top && window.frameElement.id === 'x1-iframe') {
    window.top.postMessage(
        {
          action: 'logout-from-xentral',
          item1: 'appLoggedOutScript', // id
          item2: `Window missmatch. Frame element: ${window.frameElement.id}`, // ctx
          item9: true, // isTriggeredFromX1
          item10: false, // isTriggeredManually
        },
        '*'
      )
}
